import type { TApiColumnMappingFieldType } from "@/apis/proda_finance";

export type TColumnMappingFieldConfig = {
    fieldType: TApiColumnMappingFieldType;
    label: string;
    required: boolean;
    glOnly?: boolean;
};

// Revantage APAC lines are identified by entity, asset and investment, each
// resolved through its own mapping workbook. Entity (`local_propcode`) and
// investment are required; asset and source system are optional. Field order
// follows `_TB_FIELDS` in file_type_columns.py.
export const TB_COLUMN_FIELDS: TColumnMappingFieldConfig[] = [
    { fieldType: "amount", label: "Amount", required: true },
    { fieldType: "local_propcode", label: "Entity ID", required: true },
    { fieldType: "investment_id", label: "Investment ID", required: true },
    { fieldType: "asset_id", label: "Asset ID", required: false },
    { fieldType: "source_system", label: "Source System", required: false },
    { fieldType: "source_account_name", label: "Source Account Name", required: true },
    { fieldType: "source_account_number", label: "Source Account Number", required: true },
    { fieldType: "details_notes", label: "Details Notes", required: false },
    { fieldType: "ref", label: "Ref", required: false },
    { fieldType: "opening_balance", label: "Opening Balance", required: false },
];

export const GL_COLUMN_FIELDS: TColumnMappingFieldConfig[] = [
    { fieldType: "amount", label: "Amount", required: true },
    { fieldType: "date", label: "Date", required: true, glOnly: true },
    { fieldType: "period", label: "Period", required: true, glOnly: true },
    { fieldType: "details_notes", label: "Details Notes", required: false },
    { fieldType: "local_propcode", label: "Local Propcode", required: true },
    { fieldType: "ref", label: "Ref", required: false },
    { fieldType: "source_account_name", label: "Source Account Name", required: true },
    { fieldType: "source_account_number", label: "Source Account Number", required: true },
];
